import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { KYMW4802Model } from './kymw4802.model';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { GetPastCrossGoodsSetListService } from './api-services/get-past-cross-goods-set-list.service';
import { UpdateTargetCrossGoodsInfoService } from './api-services/update-target-cross-goods-info.service';
import { KYMW4802InputModel } from './vo/kymw4802-input.model';
import { KYMW4802OutputModel } from './vo/kymw4802-output.model';
import { PastCrossGoodsSetList } from './vo/past-cross-goods-set-list.model';
import { TargetCrossGoodsInfo } from './vo/target-cross-goods-info.model';
import { FlexGrid, Row } from '@grapecity/wijmo.grid';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { CheckUnselectedGoods } from './vo/check-unselected-goods.model';
import { CheckUnselectedGoodsService } from '../kymw4801/api-services/check-unselected-goods.service';

/**
 * クロス商品設定画面を管理するクラス
 *
 * @export KYMW4802Component
 * @class KYMW4802Component
 */
@Component({
  selector: 'app-kymw4802',
  templateUrl: 'kymw4802.component.html',
  styleUrls: ['kymw4802.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW4802Component extends PlessViewHelperSub implements OnInit {
  public kymw4802Model: KYMW4802Model = new KYMW4802Model();
  public setKYMW4802Parameter: Function;

  // 設定ボタン非活性
  public disabledSetBtn = true;

  @ViewChild('dtg_CrossGoodsList', { static: true }) dtg_CrossGoodsList: FlexGrid;

  public readonly COLUMN_WIDTH = {
    pcode: { min: 90, default: 250 },
    guideGoodsName: { min: 180, default: 500 },
    guideStandardName: { min: 150, default: 420 },
    childKoma: { min: 80, default: 224 },
  };

  // 過去クロス商品設定一覧の列の横幅HTMLバインド用
  public colWidths = {
    pcode: this.COLUMN_WIDTH['pcode'].min,
    guideGoodsName: this.COLUMN_WIDTH['guideGoodsName'].min,
    guideStandardName: this.COLUMN_WIDTH['guideStandardName'].min,
    childKoma: this.COLUMN_WIDTH['childKoma'].min,
  };

  /**
   * Creates an instance of KYMW4802Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetPastCrossGoodsSetListService} getPastCrossGoodsSetListService
   * @param {UpdateBuyerCrossGoodsSetMasterListService} updateBuyerCrossGoodsSetMasterListService
   * @param {CheckUnselectedGoodsService} checkUnselectedGoodsService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW4802Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getPastCrossGoodsSetListService: GetPastCrossGoodsSetListService,
    private updateTargetCrossGoodsInfoService: UpdateTargetCrossGoodsInfoService,
    private checkUnselectedGoodsService: CheckUnselectedGoodsService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW4802Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4802';

    // 過去クロス商品設定一覧取得
    this.callGetPastCrossGoodsSetList();
  }

  /**
   * 一覧表選択行変更イベントハンドラ
   *
   * @memberof KYMW4802Component
   */
  public crossGoodsListChangedHandler(): void {
    // 行選択されている場合に設定ボタンを活性化
    this.disabledSetBtn = this.dtg_CrossGoodsList.selection.row < 0;
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡されるデータ
   * @memberof KYMW4802Component
   */
  public setInterfaceParam(param: KYMW4802InputModel): void {
    this.kymw4802Model.mediumType = param.mediumType;
    this.kymw4802Model.mediumName = param.mediumName;
    this.kymw4802Model.catalogId = param.catalogId;
    this.kymw4802Model.orderCode = param.orderCode;
    this.kymw4802Model.pcode = param.pcode;
    this.kymw4802Model.guideGoodsName = param.guideGoodsName;
    this.kymw4802Model.guidsStandardName = param.guidsStandardName;
  }

  /**
   * グリッドの直近企画回とヘッダー初期化
   * @param {FlexGrid} grid
   * @memberof KYMW4802Component
   */
  private initGrid(grid: FlexGrid): void {
    const extraRow = new Row();
    extraRow.allowMerging = true;
    extraRow.cssClass = 'wj-align-center display-grid';
    const panel = grid.columnHeaders;
    panel.rows.splice(0, 0, extraRow);
    ['DelivCatalogId', 'MediumName'].forEach(function (binding) {
      const col = grid.getColumn(binding);
      col.allowMerging = true;
      panel.setCellData(0, col.index, col.header);

      // 企画回と媒体のヘッダを左寄せにする
      grid.formatItem.addHandler((s, e) => {
        if (e.panel === grid.columnHeaders) {
          if (e.row === 0 && e.col === 0 || e.col === 1) {
            e.cell.classList.remove('wj-align-center');
            e.cell.classList.add('wj-align-left');
          } else if (e.row === 0 && e.col > 1) {
            // 3つ目のヘッダ（掲載順と結合されたセルの間）にボーダーを指定
            e.cell.classList.add('header-split-border');
          }
        }
      })
    });
    // グリッドの初期選択行はなしとする
    grid.select(-1, -1);
  }

  /**
   * グリッドの掲載順ヘッダー初期化
   * @param {FlexGrid} grid
   * @memberof KYMW4802Component
   */
  private initGridDisplayOrder(grid: FlexGrid) {
    const panel = grid.columnHeaders;
    // 直近企画回, 設定媒体
    const startIndex = 2;
    // Pコード, 商品名, 規格名, 子コマ配置
    const mergeCount = 4;
    // 掲載順X
    let displayOrder = 1;
    for (let i = startIndex; i < (this.kymw4802Model.displayOrderLength * mergeCount) + startIndex ; i++) {
      const seq = i - startIndex;
      if (seq !== 0 && seq % mergeCount === 0) {
        displayOrder = displayOrder + 1;
      }
      panel.setCellData(0, i, '掲載順' + displayOrder);
    }

    // 掲載順のデータが2列以下の時、掲載順ヘッダーの列を可変にする
    const list: Array<any> = this.kymw4802Model.displayList;
    if (list.length < 3) {
      Object.keys(this.colWidths).forEach((key) => {
        this.colWidths[key] = this.COLUMN_WIDTH[key].default / list.length;
      });
    }
  }

  /**
   * 過去クロス商品設定一覧取得
   *
   * @memberof KYMW4802Component
   */
  public callGetPastCrossGoodsSetList(): void {
    // 初期表示用のAPIリクエスト
    const vo: PastCrossGoodsSetList = new PastCrossGoodsSetList();
    vo.pcode = this.kymw4802Model.pcode;

    // データ取得
    this.getPastCrossGoodsSetListService.execute(this.kymw4802Model, vo, () => {
      setTimeout(() => {
        // グリッド設定
        this.initGrid(this.dtg_CrossGoodsList);
        this.initGridDisplayOrder(this.dtg_CrossGoodsList);
        this.dtg_CrossGoodsList.focus();
      });
    },
    () => {
      this.closeFunction();
    });
  }

  /**
   * 設定ボタン押下時処理
   *
   * @memberof KYMW4802Component
   */
  public async eventBtnSet_CLICKHandler(): Promise<void> {
    const target = this.dtg_CrossGoodsList.rows[this.dtg_CrossGoodsList.selection.row].dataItem;
    
    const filteredList = target.CrossGoodsSetList.filter(e => e.PCode !== '-');
    let hasUnselectedGoods = false;
    for (const e of filteredList) {
      const checkvo: CheckUnselectedGoods = new CheckUnselectedGoods();
      checkvo.orderCode = this.kymw4802Model.orderCode;
      checkvo.mediumType = this.kymw4802Model.mediumType;
      checkvo.pCode = e.PCode;
      await new Promise<void>((resolve) => {
        this.checkUnselectedGoodsService.execute(null, checkvo, (data) => {
          // チェック結果が "1" (未選定) の場合, エラーとする
          if (data.CheckResult === '1') {
            hasUnselectedGoods = true;
          }
          resolve();
        });
      });
      if (hasUnselectedGoods) break;
    }

    if (hasUnselectedGoods) {
      // エラーメッセージ「同一企画回・媒体で選定されていない商品が含まれています。」
      this.dialogService.openAlertGetMessage('E0602');
      return;
    }

    const vo: TargetCrossGoodsInfo = new TargetCrossGoodsInfo();
    vo.orderCode = this.kymw4802Model.orderCode;
    vo.selectOrderCode = target.OrderCode;
    vo.crossCode = target.CrossCode;
    vo.mediumType = this.kymw4802Model.mediumType;
    vo.pcode = this.kymw4802Model.pcode;

    this.updateTargetCrossGoodsInfoService.execute(this.kymw4802Model, vo, () => {
      const outputVo = new KYMW4802OutputModel();
      for (const e of filteredList) {
        outputVo.pcodeList.push(e.PCode);
      }
      this.setKYMW4802Parameter(outputVo);
      this.closeFunction();
    }, () => {
      this.closeFunction();
    });
  }

  /**
   * 閉じるボタン押下時処理
   *
   * @memberof KYMW4802Component
   */
  public onClickWindowClose() {
    if (this.dtg_CrossGoodsList.selection.row >= 0) {
      this.dialogService.openAlertGetMessage('Q0110', null,
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            super.onClickWindowClose();
          }
        });
    } else {
      super.onClickWindowClose();
    }
  }
}
